import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f6ca5e40")

_pushScopeId("data-v-f6ca5e40")
const _hoisted_1 = { class: "not-found" }
const _hoisted_2 = { class: "not-found-content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title pc-ver" }, "404 Not Fonud", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "title sp-ver" }, "404", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", { class: "sp-ver sub-title" }, "Not Found", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "お探しのページが見つかりません。", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, "リンクに問題があるか、ページが削除された可能性があります。", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BaseRoundRectButton = _resolveComponent("BaseRoundRectButton")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withId(() => [
          _createVNode(_component_BaseRoundRectButton, {
            class: "btn-black back-top",
            text: "TOPへ戻る"
          })
        ]),
        _: 1
      })
    ])
  ]))
})